
<div class="tab-pane fade show "  id="pills-Builds"
    role="tabpanel" aria-labelledby="pills-Builds-tab">
    <div class="wish-list mb-3">
      <div class="row g-4">
        <ng-container
        *ngIf=" ((totalItemsConfigurator == 0 || activityDeatils?.length == 0) && apicalled) ;else productTemplateofcongirator">
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4"
            *ngFor="let item of skeletonService.generateFake(3);let i = index;">
            <div class="poduct-item">
              <div class="d-flex align-items-center tagf">
                <ngx-skeleton height="30px" width="230px"></ngx-skeleton>
              </div>
              <div class="img-wrapper">
                <ngx-skeleton height="220px" width="230px"></ngx-skeleton>
              </div>
              <div class="d-grid gap-1 wish-content">
                <div class="cv-name text-ellipsis">
                  <ngx-skeleton height="30px" width="230px"></ngx-skeleton>
                </div>
                <div class="price ">
                  <ngx-skeleton height="20px" width="230px"></ngx-skeleton>
                </div>
                <div class="rating">
                  <ngx-skeleton height="20px" width="230px"></ngx-skeleton>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
    <ng-template #productTemplateofcongirator>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4" *ngFor="let item of activityDeatils | paginate: {
        itemsPerPage: itemsperpageconfigurator,
        currentPage: currentPageConfigurator,
        totalItems: totalItemsConfigurator,
        id: 'activitydetailed'
      }">
            <div class="poduct-item">
              <div class="d-flex align-items-center tagf">
              </div>
              <div class="img-wrapper">
                <a>
                  <img alt="Loading" *ngIf="item?.vc_images?.exteriorImage"
                    src="{{item?.vc_images?.exteriorImage[0]}}" loading="lazy" class="img-fluid cursor"
                    (click)="getdataofconfiguratorjson(item)" />
                </a>
                <img *ngIf="!item?.vc_images?.exteriorImage"
                [src]="environment1 + 'assets/images/config-default.webp'" alt="default_vehicle_img"
                  loading="lazy" style="height: 216px; cursor: pointer;
                width: 244px;" (click)="getdataofconfiguratorjson(item)" class="img-fluid cursor">
              </div>
              <div class="d-grid gap-1 wish-content">

                <div class="price" style="cursor:pointer" *ngIf="item?.configuration_id"
                  (click)="getdataofconfiguratorjson(item)">
                  {{(item?.configuration_id)}} <span class="ex-show ps-1">
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 empty-states"
          *ngIf="activityDeatils?.length == 0">
          <img [src]='environment1 + "assets/images/no_vehicle_booked.svg"' loading="lazy">
          <h3>
            No Vehicles Booked
          </h3>
          <div class="desc">
            You haven’t booked any vehicles at <br />the moment.
          </div>
        </div>
        <div class="paging-custom">
          <pagination-controls *ngIf="totalItemsConfigurator > itemsperpageconfigurator"
            (pageChange)="pageChangeConfigurator($event)" previousLabel=" " nextLabel=" "
            id='activitydetailed' ></pagination-controls>
        </div>
      </div>
    </div>
  </div>
